/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const TradeMaterialsListSection = ({ title, description, media }) => {
  return (
    <Box py={[7, 9]}>
      <Container>
        <Grid
          columns={[1, 12]}
          pb={[7, 6]}
          sx={{
            rowGap: 0,
          }}
        >
          <Box
            sx={{
              gridColumn: [null, '2 / 12'],
              textAlign: 'center',
            }}
          >
            <Heading as="h1" variant="title1">
              {title}
            </Heading>
          </Box>
          {description && (
            <Box
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
              mt={2}
              sx={{
                gridColumn: [null, '3 / 11'],
                textAlign: 'center',
                '& p, & ul, & ol': {
                  mt: 0,
                  variant: 'text.body1',
                },
              }}
            />
          )}
        </Grid>
        <Grid
          columns={[1, 2, null, 3]}
          sx={{
            m: '0 auto',
            maxWidth: ['475px', 'none'],
            rowGap: 9,
          }}
        >
          {media.map((card) => (
            <TradeMaterialsListCard
              key={`trade-materials-card-${card.id}`}
              media={card.media}
              subtitle={card.subtitle}
              title={card.title}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

const TradeMaterialsListCard = ({ media, subtitle, title }) => {
  return (
    <a
      href={subtitle}
      target="_blank"
      rel="noreferrer"
      title={`${title} (opens in a new window)`}
      sx={{
        color: 'black',
        display: 'block',
        textDecoration: 'none',
        width: '100%',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      <Box
        mb={3}
        px={3}
        sx={{
          height: '232px',
          overflow: 'hidden',
          position: 'relative',
          '&:after': {
            bg: 'backgroundDark',
            borderRadius: '80px 80px 0 0',
            bottom: '0',
            content: "''",
            height: '160px',
            left: '0',
            margin: '0 auto',
            maxWidth: '320px',
            position: 'absolute',
            right: '0',
          },
        }}
      >
        <GatsbyImage
          image={media?.gatsbyImageData}
          alt={media?.description}
          key={media?.title}
          sx={{
            bottom: '-8px',
            left: '0',
            margin: '0 auto',
            maxWidth: '220px',
            position: 'absolute',
            right: '0',
            transition: 'all .15s ease-in-out',
            zIndex: '1',
            'a:hover &': {
              bottom: '0',
            },
          }}
        />
      </Box>
      <Heading
        as="h2"
        variant="title4"
        mt={2}
        mb="4px"
        px={1}
        sx={{ textAlign: 'center' }}
      >
        {title}
      </Heading>
    </a>
  )
}

export default TradeMaterialsListSection
